import { type FormEvent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SearchInput from '@/components/common/search-input';
import useAdjustLayout from '@/hooks/use-adjust-layout';

interface SearchBarProps {
  keyword?: string;
  onSearch: (keyword: string) => void;
}

export default function SearchBar({ keyword = '', onSearch }: SearchBarProps) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(keyword);
  const searchInput = useRef<HTMLInputElement>(null);

  const onSubmit = (el: FormEvent) => {
    el.preventDefault();

    const sanitizedKeyword = inputValue?.trim();
    if (sanitizedKeyword) onSearch(sanitizedKeyword);
    searchInput.current?.blur();
    (document.activeElement as HTMLElement).blur();
  };

  useAdjustLayout({ inputTargetSelector: 'input#search-input' });

  useEffect(() => {
    if (keyword) {
      setInputValue(keyword);
    }
  }, [keyword]);

  return (
    <div className='flex relative w-full items-center gap-2'>
      <form
        onSubmit={onSubmit}
        className='flex-1 flex items-center dropdown'>
        <SearchInput
          keyword={inputValue}
          setKeyword={setInputValue}
          clearKeyword={() => {
            setInputValue('');
            onSearch('');
          }}
          ref={searchInput}
          placeholder={t('search.search-contact-group-chat')}
          className='m-0 xs:mx-0 flex-1 mode-embedded:h-7 mode-embedded:text-body'
        />

        <button
          type='submit'
          className='btn btn-ghost btn-sm px-0 pl-4 text-primary mode-embedded:text-primary-content'>
          {t('search.placeholder')}
        </button>
      </form>

      {/*<SearchHistory onSearch={onSearch} />*/}
    </div>
  );
}
